import type { ButtonHTMLAttributes, ReactNode } from 'react';

import { cn } from '@/utils/cn';

type ButtonVariant = 'app' | 'onboarding';
type ButtonTone = 'primary' | 'secondary' | 'danger' | 'link';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  className?: string;
  variant?: ButtonVariant;
  tone?: ButtonTone;
  children: ReactNode;
};

export function Button({ className, variant = 'app', tone = 'primary', type = 'button', children, ...props }: ButtonProps) {
  return (
    <button
      type={type}
      className={cn('button', `button--${tone}`, variant === 'onboarding' && 'button--onboarding', className)}
      {...props}
    >
      {children}
    </button>
  );
}
